import { Component } from '@angular/core';

@Component({
  selector: 'app-default-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent {}
